import { Globe, Monitor, Smartphone } from '../../../icons';
import { PendingRow } from '../PendingRow';
import { tSettings } from '../../../lib/settings-i18n';

/**
 * 보안설정의 "아직 서버가 없는" 세 항목 (2026-08-20 하위 메뉴 분리).
 *
 * 셋 다 원래 `SecurityPanel` 안에서 비밀번호 변경 아래 나란히 있던 것이다. 한 화면에 섞여
 * 있으니 **무엇이 되고 무엇이 준비 중인지** 흐릿했다 — 하위로 가르면 "준비 중" 이 어디에
 * 걸린 것인지 분명해진다. 화면 내용은 옮기기만 했고 동작은 그대로 없다(서버에 국가 판정·
 * 세션 목록 API 가 아직 없다 — 2026-08-12 판단 유지).
 */

function Section({ heading, children }: { heading: string; children: React.ReactNode }) {
  return (
    <section className="settings-section" aria-label={heading}>
      <h2>{heading}</h2>
      <p className="settings-section-subtitle">{tSettings('settings.modal.pending_note')}</p>
      <div className="st-rows">{children}</div>
    </section>
  );
}

/** 해외 로그인 차단 — 허용 국가 밖 로그인 차단(준비 중). */
export function SecurityGeoPanel() {
  return (
    <Section heading={tSettings('settings.modal.security.geo_title')}>
      <PendingRow
        icon={<Globe size={15} />}
        title={tSettings('settings.modal.security.geo_title')}
        desc={tSettings('settings.modal.security.geo_desc')}
      />
    </Section>
  );
}

/** 로그인 기기 정보 — 로그인된 브라우저·기기 목록(준비 중). */
export function SecurityDevicesPanel() {
  return (
    <Section heading={tSettings('settings.modal.security.sessions_title')}>
      <PendingRow
        icon={<Monitor size={15} />}
        title={tSettings('settings.modal.security.sessions_title')}
        desc={tSettings('settings.modal.security.sessions_desc')}
        control="badge"
      />
    </Section>
  );
}

/** 등록된 모바일 기기 — 푸시 토큰이 등록된 기기 관리(준비 중). */
export function SecurityMobilePanel() {
  return (
    <Section heading={tSettings('settings.modal.security.mobile_title')}>
      <PendingRow
        icon={<Smartphone size={15} />}
        title={tSettings('settings.modal.security.mobile_title')}
        desc={tSettings('settings.modal.security.mobile_desc')}
        control="badge"
      />
    </Section>
  );
}
